import { render } from "./SwitchLang.vue?vue&type=template&id=276ce39c"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"

import "./SwitchLang.vue?vue&type=style&index=0&id=276ce39c&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__